import { COLORS } from '@btime/constants'
import { useDropzone } from 'react-dropzone'
import { useTranslation } from 'react-i18next'
import React from 'react'

import IconButton from '../actions/IconButton'

const LocalFileInput = ({ value, onChange, buttonLabel, accept, ...props }) => {
  const { t } = useTranslation()
  const { getRootProps, getInputProps, isDragActive, acceptedFiles } = useDropzone({
    onDrop: files => onChange({ ...files[0], preview: URL.createObjectURL(files[0]) }),
    accept: accept || 'image/*,application/*'
  })

  if (!!value)
    return (
      <IconButton
        label={t('remove')}
        transparent
        color={COLORS.red}
        borderColor={COLORS.light3}
        small
        icon="BsTrash"
        iconSize=".8rem"
        onClick={() => onChange(undefined)}
      />
    )

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <IconButton
        label={buttonLabel || t('selectFile')}
        transparent={!isDragActive}
        color={COLORS.dark3}
        borderColor={COLORS.light3}
        small
        icon="BsCardImage"
        iconSize="1.1rem"
      />
    </div>
  )
}

export default LocalFileInput
